<template>
  <div>
    <el-table :data="items" size="small" class="mt-10" v-loading="loading">
      <el-table-column label="成品分类" prop="template.name"></el-table-column>
      <el-table-column
        align="center"
        label="所属基地"
        prop="base.name"
      ></el-table-column>
      <el-table-column align="center" label="钻井" prop="well.well_number">
      </el-table-column>
      <el-table-column
        align="center"
        label="开井时间"
        prop="well.start_serve_date"
      >
      </el-table-column>
      <el-table-column
        align="center"
        label="完井时间"
        prop="well.end_serve_date"
      >
      </el-table-column>
      <el-table-column align="center" label="区块" prop="well.well_block">
      </el-table-column>
      <el-table-column align="center" label="服务人员">
        <template slot-scope="scope">{{
          scope.row.well.service_staff_names
            ? scope.row.well.service_staff_names.join('、')
            : ''
        }}</template>
      </el-table-column>
      <el-table-column align="center" label="库存数量" prop="count">
        <template slot-scope="scope">
          <el-link
            class="font-12"
            type="primary"
            :underline="false"
            @click="
              handleShowDetail(
                scope.row.base_id,
                scope.row.product_template_id,
                scope.row.drill_well_id,
                scope.row.template.code_type,
              )
            "
          >
            <template v-if="scope.row.template.code_type == 2 && status == 1">{{
              scope.row.count - scope.row.used_count
            }}</template>
            <template
              v-else-if="scope.row.template.code_type == 2 && status == 2"
              >{{ scope.row.used_count }}</template
            >
            <template v-else>{{ scope.row.count }}</template>
          </el-link>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    items: null,
    loading: false,
    status: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    handleShowDetail(baseid, templateid, wellid, codeType = 1) {
      let filter = {
        product_template_id: templateid,
        drill_well_id: wellid,
        base_ids: [baseid],
        page: 1,
        size: 10,
        tab: 'second',
        stock_type: 0,
      }
      this.$router.push(
        `/${
          codeType == 2 ? 'group_instruments' : 'instruments'
        }?filter=${JSON.stringify(filter)}`,
      )
    },
  },
}
</script>